// extracted by mini-css-extract-plugin
module.exports = {"BigButtonsContainer":"isros_BigButtonsContainer__3C4VP","BigButton":"isros_BigButton__snVb1","ButtonsFlexContainer":"isros_ButtonsFlexContainer__2UDKn"};